export default __webpack_public_path__ + "static/media/xp-network.ce8f3009.svg";